module.exports = __webpack_public_path__ + "static/img/ICashPay.3d3d0043.png";